import { render, staticRenderFns } from "./CheckoutStep.vue?vue&type=template&id=5c4e837a"
import script from "./CheckoutStep.vue?vue&type=script&lang=js"
export * from "./CheckoutStep.vue?vue&type=script&lang=js"
import style0 from "./CheckoutStep.vue?vue&type=style&index=0&id=5c4e837a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports